
import * as Yup from 'yup';
import { TabOption } from '../../../shared/components/FormTabHeader';

export interface IGeneralExpenseModel {
    id: string;
    // Gider İşlemleri
    date: string;
    amount: number;
    tax: number;
    expenseName: string;
    branch: string;
    documentNumber: string;
    operator: string;

    // Ödeme Bilgisi
    paymentDate: string;
    paymentAmount: number;
    paymentType: string;
    cashCode: string;
    iban: string;
    description: string;
    contractNumber: string;

    // Cari Bilgisi
    customer: string;
    filePath: string;
}

export const initialGeneralExpense: IGeneralExpenseModel = {
    id: '',
    // Gider İşlemleri
    date: '',
    amount: 0,
    tax: 0,
    expenseName: '',
    branch: '',
    documentNumber: '',
    operator: '',

    // Ödeme Bilgisi
    paymentDate: '',
    paymentAmount: 0,
    paymentType: '',
    cashCode: '',
    iban: '',
    description: '',
    contractNumber: '',

    // Cari Bilgisi
    customer: '',
    filePath: '',
};



export const validationGeneralExpense = Yup.object({
    // Gider İşlemleri
    date: Yup.string()
        .required('Tarih zorunludur'),

    amount: Yup.number()

        .required('Tutar zorunludur'),

    tax: Yup.number()

        .min(0, 'Vergi negatif olamaz')
        .required('Vergi zorunludur'),

    expenseName: Yup.string()
        .required('Gider adı zorunludur')
        .max(100, 'Gider adı en fazla 100 karakter olmalıdır'),

    branch: Yup.string()
        .required('İşlem şube zorunludur')
        .max(100, 'İşlem şube en fazla 100 karakter olmalıdır'),

    documentNumber: Yup.string()
        .required('Evrak numarası zorunludur')
        .max(50, 'Evrak numarası en fazla 50 karakter olmalıdır'),

    operator: Yup.string()
        .required('İşlem yapan kişi zorunludur')
        .max(100, 'İşlem yapan en fazla 100 karakter olmalıdır'),

    // Ödeme Bilgisi
    paymentDate: Yup.string()
        .required('Ödeme tarihi zorunludur'),

    paymentAmount: Yup.number()

        .required('Ödeme tutarı zorunludur'),

    paymentType: Yup.string()
        .required('Ödeme türü zorunludur')
        .max(50, 'Ödeme türü en fazla 50 karakter olmalıdır'),

    cashCode: Yup.string()
        .required('Kasa kodu zorunludur')
        .max(50, 'Kasa kodu en fazla 50 karakter olmalıdır'),

    iban: Yup.string()
        .required('IBAN zorunludur')
        .max(50, 'IBAN en fazla 50 karakter olmalıdır'),


    description: Yup.string()
        .required('Açıklama zorunludur')
        .max(500, 'Açıklama en fazla 500 karakter olmalıdır'),

    contractNumber: Yup.string()
        .required('Sözleşme numarası zorunludur')
        .max(50, 'Sözleşme numarası en fazla 50 karakter olmalıdır'),

    // Cari Bilgisi
    customer: Yup.string()
        .required('Cari zorunludur')
        .max(100, 'Cari en fazla 100 karakter olmalıdır'),

    filePath: Yup.string()
        .required('Dosya yolu zorunludur')
});

export const tabOptions: TabOption<'form' | 'list'>[] = [
    { key: 'form', title: 'Yeni Genel Gider', },
    { key: 'list', title: 'Araç Gider Listesi', }]

export const currencyOptions = [
    { value: 'TRY', label: 'TL' },
    { value: 'USD', label: 'USD' },
    { value: 'EUR', label: 'EUR' },
];
export const expenseOptions = [
    { value: 'MUTFAK', label: 'Mutfak Gideri' },
    { value: 'KIRTASIYE', label: 'Kırtasiye' },
    { value: 'TEMIZLIK', label: 'Temizlik' },
];

export const paymentTypeOptions = [
    { value: 'NAKIT', label: 'Nakit' },
    { value: 'KREDI_KARTI', label: 'Kredi Kartı' },
    { value: 'HAVALE_EFT', label: 'Havale/EFT' },
]

export const cashCodeOptions = [
    { value: 'MERKEZ', label: 'MERKEZ' },
    { value: 'SUBE', label: 'ŞUBE' },
]

export const ibanOptions = [
    { value: 'TRXXXXXX1', label: 'ŞAHSİ HESAP – TL' },
    { value: 'TRXXXXXX2', label: 'ŞİRKET HESABI – TL' },
]

